/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Add_Expiration_LabelInputs */



/**
* | output |
* | --- |
* | "Expiration" |
*
* @param {Profile_Security_User_Api_Key_Add_Expiration_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_add_expiration_label = /** @type {((inputs?: Profile_Security_User_Api_Key_Add_Expiration_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Add_Expiration_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ablaufdatum")
	return /** @type {LocalizedString} */ ("Expiration")
});